"use client";

import {
	Toaster as ChakraToaster,
	Portal,
	Spinner,
	Stack,
	Toast,
	createToaster,
} from "@chakra-ui/react";

export const toaster = createToaster({
	placement: "top-end",
	pauseOnPageIdle: true,
});

export const Toaster = () => {
	return (
		<Portal>
			<ChakraToaster
				toaster={toaster}
				insetInline={{ mdDown: "4" }}
				zIndex={10000}
			>
				{(toast) => {
					const customStyle = toast.meta?.customStyle;
					const bgColor = customStyle?.background || undefined;
					const textClass = customStyle?.textClass || "";

					return (
						<Toast.Root
							width={{ md: "sm" }}
							bg={bgColor}
							className={customStyle?.className}
						>
							{toast.type === "loading" ? (
								<Spinner size="sm" color="blue.solid" />
							) : (
								<Toast.Indicator />
							)}
							<Stack gap="1" flex="1" maxWidth="100%">
								{toast.title && (
									<Toast.Title className={textClass}>{toast.title}</Toast.Title>
								)}
								{toast.description && (
									<Toast.Description className={textClass}>
										{toast.description}
									</Toast.Description>
								)}
							</Stack>
							{toast.action && (
								<Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
							)}
							{toast.meta?.closable && <Toast.CloseTrigger />}
						</Toast.Root>
					);
				}}
			</ChakraToaster>
		</Portal>
	);
};
